import React, { useState } from "react";
import { Col, Layout, Row, Tooltip, Modal } from "antd";
import { RiCloseFill } from "react-icons/ri";
export default function MenuFooter() {
  const { Footer } = Layout;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <Footer className="hp-bg-color-black-10 hp-bg-color-dark-100">
      <Row align="middle" justify="space-between">
        <Col md={12} span={24}>
          <p className="hp-badge-text hp-mb-0 hp-text-color-dark-30">
            COPYRIGHT ©2023 Orevan, All rights Reserved
          </p>
        </Col>
        <Col md={12} span={24}>
          <Tooltip title="ChangeLog?">
            <p className="hp-badge-text hp-mb-0 hp-text-color-dark-30" style={{ float: 'right', color: "#3182ad", cursor: "pointer"}} onClick={showModal}>
              V2 Beta
            </p>
          </Tooltip>
        </Col>
      </Row>
      <Modal
        width={416}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        onCancel={handleCancel}
        closeIcon={
          <RiCloseFill
            className="remix-icon text-color-black-100"
            size={24}
          />
        }
      >
        <img src="https://media0.giphy.com/media/L0O7hughPslHvVx9A4/giphy.gif?cid=790b76111ada305799d08ae65be35ddd46b6556eea049a6e&rid=giphy.gif&ct=g" alt="" />
      </Modal>
    </Footer>
  );
};